/** Raw statuses returned by the shared job-status endpoint for a refinement
 * workflow. See CallRefinementStatus for how these map to the 3 generic UI
 * states (Thinking/Updated/Error). */
export enum CallRefinementServerStatus {
  Requested = 'REFINEMENT_REQUESTED',
  ChangePlan = 'REFINEMENT_CHANGE_PLAN',
  SectionRewrite = 'REFINEMENT_SECTION_REWRITE',
  Completed = 'REFINEMENT_COMPLETED',
  Failed = 'REFINEMENT_FAILED',
}
